/**
 * Canonical scrollbar styles for the Graniot application.
 * See docs/design-system.md for usage guidelines.
 */

const baseColors = {
  track: 'transparent',
  thumb: 'rgba(0, 0, 0, 0.2)',
  thumbHover: 'rgba(0, 0, 0, 0.3)',
}

/** Default scrollbar — 6px, for drawers, panels, lists */
export const scrollbarStyles = {
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    background: baseColors.track,
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: baseColors.thumb,
    borderRadius: '10px',
    '&:hover': {
      background: baseColors.thumbHover,
    },
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${baseColors.thumb} ${baseColors.track}`,
}

/** Wide scrollbar — 8px, tighter radius, for data tables and dense content */
export const scrollbarStylesWide = {
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: baseColors.track,
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: baseColors.thumb,
    borderRadius: '4px',
    '&:hover': {
      background: baseColors.thumbHover,
    },
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${baseColors.thumb} ${baseColors.track}`,
}

/** Horizontal scrollbar — 8px height only, for carousels and horizontal lists */
export const scrollbarStylesHorizontal = {
  '&::-webkit-scrollbar': {
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: baseColors.track,
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: baseColors.thumb,
    borderRadius: '10px',
    '&:hover': {
      background: baseColors.thumbHover,
    },
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${baseColors.thumb} ${baseColors.track}`,
}
